// CashSaverModal.jsx
import React from "react";
import { X } from "lucide-react";
import "./ViewMore.css";
import { useGetavailablecuponsQuery } from "../../../../services/addMoneyApi";

export default function ViewMore({
  open,
  setOpen,
  coupon,
  paymentType,
  appliedCoupon,
  setAppliedCoupon,
}) {
  if (!open) return null;
  const { couponText, title, shortDescription, description, value } = coupon;
  let discount;
  if (paymentType === "Point") {
    discount = `${value * 100} Points`;
  } else if (paymentType === "USDT") {
    discount = `$${(value / 100).toFixed(4)}`;
  } else discount = `₹${value}`;
  return (
    <div className="csm-backdrop">
      <div className="csm-sheet">
        <button
          className="csm-close"
          onClick={() => {
            setOpen(false);
          }}
          aria-label="Close"
        >
          <X size={24} />
        </button>
        <div className="header">
          <div className="couponBadge">
            <h2 className="csm-title">{couponText}</h2>
          </div>
        </div>
        <p className="csm-subtitle">{shortDescription}!</p>
        <ul className="csm-list">
          {description.split("\n").map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
          <li>Get {discount} OFF</li>
        </ul>
        <button
          className={`csm-apply ${
            appliedCoupon === coupon ? "csm-applied" : ""
          }`}
          onClick={() => {
            setAppliedCoupon(coupon);
            setOpen(false);
          }}
        >
          {appliedCoupon === coupon ? "Already Applied" : "Apply Coupon"}
        </button>
      </div>
    </div>
  );
}
